/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2019 Deere & Company

import {
    ImplicitCallback, SecureRoute, withAuth,
} from '@okta/okta-react';
import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import OktaStateStruct from '../state/okta-state';
import PropTypes from 'prop-types';
import RoutingComponent from '../../routing/routingComponent';

class OktaState extends Component {

    async componentDidMount() {

        this.checkAuthentication();

        this.setUsername();

    }

    async componentDidUpdate() {

        this.checkAuthentication();

        if (!this.props.oktaState.userName) {

            this.setUsername();

        }

    }

    async setUsername() {

        if (this.props.oktaState.isAuthenticated && !this.props.oktaState.userName) {

            const user = await this.props.auth.getUser();
            if (user) {

                this.checkAuthorisedRole(user);
                this.props.updateOktaUserName(user.name);
                this.props.updateOktaUserId(user.userID);

            }

        }

    }

    checkAuthorisedRole(user) {

        if (user.warrantyApiAdgroups === undefined || (user.warrantyApiAdgroups && !user.warrantyApiAdgroups.includes('JDWS_MANAGE_ADMIN'))) {

            this.props.history.push('/unauthorizeerror');

        }

    }

    async checkAuthentication() {

        const isAuthenticated = await this.props.auth.isAuthenticated();
        if (isAuthenticated !== this.props.oktaState.isAuthenticated) {

            this.props.updateOktaIsAuthenticated(isAuthenticated);

        }

    }

    render() {

        return (this.props.oktaState.isAuthenticated && this.props.oktaState.userName ?
            <RoutingComponent /> : (
                <Switch>
                    <Route component={ImplicitCallback} path="/callback" />
                    <SecureRoute component={() => null} />

                </Switch>
            ));

    }

}

OktaState.propTypes = {
    updateOktaIsAuthenticated: PropTypes.func.isRequired,
    updateOktaUserId: PropTypes.func.isRequired,
    updateOktaUserName: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    oktaState: PropTypes.instanceOf(OktaStateStruct).isRequired,
    history: PropTypes.any,
};

export default withRouter(withAuth(OktaState));
